import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { chartApi } from '../services/api';
import { Chart } from '../types';
import ChartCard from '../components/ChartCard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchPage: React.FC = () => {
  const query = useQuery();
  const tag = query.get('tag') || query.get('q') || '';
  const [charts, setCharts] = useState<Chart[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCharts = async () => {
      try {
        setLoading(true);
        const allCharts = await chartApi.getAllCharts();
        const filtered = allCharts.filter(chart =>
          (chart.title && chart.title.toLowerCase().includes(tag.toLowerCase())) ||
          (chart.category && chart.category.toLowerCase().includes(tag.toLowerCase())) ||
          (chart.sub_category && chart.sub_category.toLowerCase().includes(tag.toLowerCase())) ||
          (Array.isArray(chart.keywords) && chart.keywords.some(k => k && k.toLowerCase().includes(tag.toLowerCase())))
        );
        setCharts(filtered);
      } catch (err) {
        setError('검색 결과를 불러오는데 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };
    if (tag) fetchCharts();
  }, [tag]);

  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <Container className="py-5">
        <Row className="mb-4">
          <Col className="text-center">
            <h2 className="fw-bold gradient-text mb-2">'{tag}' 태그로 검색된 차트</h2>
            <button className="btn btn-main mt-2" onClick={() => navigate(-1)}>돌아가기</button>
          </Col>
        </Row>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <Alert variant="danger">{error}</Alert>
        ) : charts.length === 0 ? (
          <Alert variant="info">검색 결과가 없습니다.</Alert>
        ) : (
          <Row>
            {charts.map(chart => (
              <Col key={chart.id} lg={4} md={6} className="mb-4">
                <ChartCard chart={chart} categories={[]} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default SearchPage; 